import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Children } from 'react';
import { Center, Stack, Flex, Grid, GridItem, Box } from '@chakra-ui/react';
var _excluded = ["variant", "wrap", "children"];
var Layout = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'box' : _ref$variant,
    wrap = _ref.wrap,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */
  if (variant === 'center') {
    return /*#__PURE__*/React.createElement(Center, _extends({
      "data-object-type": "core-layout-center",
      ref: ref
    }, rest), children);
  }
  if (variant === 'stack') {
    return /*#__PURE__*/React.createElement(Stack, _extends({
      "data-object-type": "core-layout-stack"
    }, wrap && {
      direction: 'row',
      flexWrap: 'wrap'
    }, {
      ref: ref
    }, rest), rest !== null && rest !== void 0 && rest.passPropsDownstream ? Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread2({}, rest));
      }
      return child;
    }) : children);
  }
  if (variant === 'flex') {
    return /*#__PURE__*/React.createElement(Flex, _extends({
      "data-object-type": "core-layout-flex",
      ref: ref
    }, rest), children);
  }
  if (variant === 'grid') {
    return /*#__PURE__*/React.createElement(Grid, _extends({
      ref: ref,
      "data-object-type": "core-layout-grid"
    }, rest), Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        var _child$props;
        return /*#__PURE__*/React.createElement(GridItem, {
          key: child.key,
          display: child.props.display,
          colSpan: (child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.colSpan) || 1
        }, child);
      }
      return child;
    }));
  }
  if (variant === 'container') {
    return /*#__PURE__*/React.createElement(Box, _extends({
      ref: ref,
      "data-object-type": "core-layout-container"
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    "data-object-type": "core-layout-box"
  }, rest), children);
});
Layout.displayName = 'Layout';
export { Layout };